import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import { Button, Container, Image } from 'react-bootstrap';
import api from '../../../services/client';
import { useParams, useHistory } from 'react-router';
import parse from "html-react-parser";
import styled from 'styled-components';
import { MdArrowBackIos } from "react-icons/md";

const CompanyLogoImg = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
`;

const Title = styled.div`
    display: flex;
    margin: auto;
    padding-bottom: 20px;
    font-size: 40px;
    font-weight:500;
`;

const JobListTitle = styled.div`
    display: flex;
    margin: auto;
    padding-bottom: 10px;
    font-size: 25px;
    font-weight:500;
`;

const BackButton = styled.div`
    margin-top: 10px;
    width: 90px;
    height: 38px;
    border-radius: 10%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    background: #F4F4F4;
    cursor: pointer;
    padding: 20px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    &:hover {
        background: #0A3BB4;
        color: white;
    }
`;


function JobListByCompany(props) {
    const history = useHistory();
    const { companyId } = useParams();
    const [companyDetail, setCompanyDetail] = useState({});
    const [showForm, setShowForm] = useState(false);
    const imageBaseUrl='https://jobs.intellectualpoint.com/'

    useEffect(async () => {
       await api.getCompanyDetails(companyId).then(result => {
            setCompanyDetail(result.data);
            setShowForm(true);
        }).catch(error => {    });
    }, [])
    
    return showForm && (
        <Container>    
            <BackButton style={{marginTop: '10px'}} onClick={() => history.push('/')} > <MdArrowBackIos /> Back </BackButton>
           <CompanyLogoImg>           
            {companyDetail.CompanyLogo && <Image src={companyDetail.CompanyLogo} style ={{maxHeight: '140px'}}/> }
           </CompanyLogoImg>
            <Title>
                {companyDetail.CompanyName}
            </Title>
            {companyDetail?.Description && parse(companyDetail?.Description)}
            <JobListTitle> Jobs </JobListTitle>
            {companyDetail?.CareerLink && parse(companyDetail?.CareerLink.replace(/<a /gm,"<a target='_blank'"))}
            {!companyDetail?.CareerLink && 'No Jobs Posted'}
        </Container>
    )
}

JobListByCompany.propTypes = {

}

export default JobListByCompany

